// It's not obvious due to the @withUpgradeModal decorator,
// but this component only requires the "feature" prop
// when gating for the current location.

import './UpgradeWrapper.scss';

import React, { cloneElement, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { omit } from 'lodash';
import PropTypes from 'prop-types';

import * as sessionSelectors from 'selectors/session';
import { getWebview } from 'selectors/session';

import Box from 'components/Box';

import cxHelpers from 'util/className';

import withUpgradeModal from '../withUpgradeModal';

@withUpgradeModal
@connect((state, { feature, report }) => ({
  currentLocationCanAccess: sessionSelectors.getHasFeature(state, {
    feature,
  }),
  currentLocationCanReportAccess: sessionSelectors.getHasReport(state, {
    report,
  }),
  isWebview: getWebview(state),
}))
@cxHelpers('UpgradeWrapper')
export default class UpgradeWrapper extends PureComponent {
  static propTypes = {
    location: PropTypes.instanceOf(Map),
    onShowUpgradeModal: PropTypes.func,
    feature: PropTypes.string.isRequired,
    report: PropTypes.string,
    paywallVersion: PropTypes.string,
    currentLocationCanAccess: PropTypes.bool,
    currentLocationCanReportAccess: PropTypes.bool,
    onClick: PropTypes.func,
    locationProperty: PropTypes.string,
    serverKey: PropTypes.string,
    upgradeOffer: PropTypes.bool,
    showAsActive: PropTypes.bool,
    disabled: PropTypes.bool,
    focusedFeature: PropTypes.string,
    isWebview: PropTypes.bool,
  };

  handleShowModal = () => {
    this.props.onShowUpgradeModal?.({
      focusedFeature: this.props.focusedFeature,
    });
  };

  handleClick = () => {
    if (this.props.disabled || this.props.isWebview) {
      return;
    }

    this.handleShowModal();
    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  render() {
    const {
      children,
      location,
      feature,
      currentLocationCanAccess,
      currentLocationCanReportAccess,
      upgradeOffer,
      report,
      showAsActive,
      disabled,
      ...boxProps
    } = omit(
      this.props,
      'paywallVersion',
      'dispatch',
      'onShowUpgradeModal',
      'onClick',
      'serverKey',
      'locationProperty'
    );

    let canAccess;

    if (report) {
      canAccess = currentLocationCanReportAccess;
    } else {
      canAccess = location
        ? location.getIn(['feature_access', feature])
        : currentLocationCanAccess;
    }
    canAccess = disabled || canAccess;

    const childClassName = this.cxEl(
      'child',
      upgradeOffer || showAsActive ? null : { disabled: !canAccess },
      children.props.className
    );

    return (
      <Box {...boxProps} className={this.cx()}>
        {cloneElement(children, { className: childClassName })}
        {canAccess ? null : (
          <a className={this.cxEl('barrier')} onClick={this.handleClick} />
        )}
      </Box>
    );
  }
}
